// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
:host,
mgt-dot-options {
  font-family: 'Segoe UI'; }

:host .DotIcon,
mgt-dot-options .DotIcon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  min-width: 40px;
  min-height: 30px;
  text-align: center;
  line-height: 30px; }

:host .Menu,
mgt-dot-options .Menu {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 40px 5px;
  background: #ffffff;
  z-index: 1;
  display: none;
  color: black;
  white-space: nowrap;
  transform: translateX(-50px); }

:host .DotMenu.Open .Menu,
mgt-dot-options .DotMenu.Open .Menu {
  display: block; }

:host .DotMenu .DotItem,
mgt-dot-options .DotMenu .DotItem {
  direction: ltr;
  text-align: left;
  padding: 10px 10px 8px 10px; }

:host .DotMenu .DotItem:hover,
mgt-dot-options .DotMenu .DotItem:hover {
  background: #c0c0c0; }

:host .DotMenu .DotItem:active,
mgt-dot-options .DotMenu .DotItem:active {
  background: #d8d8d8; }

:host .DotMenu .DotItemName,
mgt-dot-options .DotMenu .DotItemName {
  direction: rtl; }

`
];
//# sourceMappingURL=mgt-dot-options-css.js.map